import { api } from "@api/api";
import { BannerDetails } from "@api/public/get/getBanners";

const deleteBanner = async (bannerID: string) => {
  const { data } = await api.post<BannerDetails>("/deleteHomeBanner", { bannerID });
  return data;
};

export default deleteBanner;
